// @flow @format
type Parameter = string | {[key: string]: boolean} | Array<Parameter>;

const classNames = (...rest: Array<Parameter>): string =>
	rest
		.reduce((classes, arg) => {
			if (typeof arg === 'object') {
				if (Array.isArray(arg)) {
					return classes.concat(classNames(...arg));
				}
				const obj = arg;
				return classes.concat(Object.keys(obj).filter(k => obj[k]));
			}
			return classes.concat(arg);
		}, [])
		.join(' ');

export default classNames;



// WEBPACK FOOTER //
// ./src/lib/classnames/index.js